$(function($) {

    var urlloc = window.location.href;
    if (urlloc.indexOf('reason') != -1){
        $.urlParam = function(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            return results[1] || 0;
        }

        var reason = $.urlParam('reason');
        $('select#q42718_q1 option:selected').removeAttr("selected");
        $('select#q42718_q1 option[value="'+ reason +  '"]').attr("selected", "selected");
        $("label[for='q42718_q1']").css({"display" : "none"});
        $('#q42718_q1').css({"height" : "0px", "padding" : "0px", "margin" : "0px", "border" : "0px" });
    }

    function validateForm() {
        $('#form_email_42718').validate({
            errorPlacement:
                function(error, element){
                    var id=element[0]['id'];
                    $( element ).before( "<label for='"+id+"' class='error'>"+error.text()+"</label>" );
                }
        });
    }

    if($('#form_email_42718').length){
        validateForm();
    }
});